<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-tooltip top>
    <template v-slot:activator="{on}">
      <a v-on="on" :href="userProfileUrl" target="_blank" class="font-weight-medium">{{user.name ? user.name : user.id}} {{user.surname}}</a>
    </template>
    <v-list two-line dark>
      <v-list-tile>
        <v-avatar class="mr-3">
          <img v-if="user.photo" :src="user.photo">
          <img v-else src="/empty-avatar.png">
        </v-avatar>
        <v-list-tile-content>
          <v-list-tile-title>
            <v-layout row align-center>
              <div>
                <span>{{user.id}} {{user.name}} {{user.surname}}</span>
              </div>
              <div
                v-if="user.volunteer === 1"
                class="primary white--text ml-2 px-3 body-1 rounded">
                <span>Волонтер</span>
              </div>
              <div
                v-if="user.volunteer === 0"
                class="success white--text ml-2 px-3 body-1 rounded">
                <span>Студент</span>
              </div>
            </v-layout>
          </v-list-tile-title>
          <v-list-tile-sub-title class="">
            {{user.email}}
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-tooltip>
</template>

<script>
import {urls} from "@/config";

export default {
  name: "UserCard",
  props: ['user'],
  data () {
    return {
      userProfileUrl: null,
    }
  },
  mounted() {
    this.userProfileUrl = urls.signin + '/u/' + this.user.uid;
  }
}
</script>

<style scoped>
  .rounded {
    border-radius: 10px;
  }

  .v-tooltip__content {
    padding: 0;
  }
</style>
